export default {
  unauthenticated: [
    { title: "Regístrate", key: "sign-up" },
    { title: "Iniciar sesión", key: "sign-in" }
  ],
  authenticated: [
    {
      title: "Panel",
      icon: "mdi-chart-bell-curve-cumulative",
      key: "dashboard",
      rootRoute: "/dashboard"
    },
    {
      title: "Ventas",
      icon: "mdi-cart-minus",
      key: "sales",
      rootRoute: "/sales"
    },
    {
      title: "Ingresos",
      icon: "mdi-cash",
      key: "incomes",
      rootRoute: "/income"
    },
    {
      title: "Egresos",
      icon: "mdi-arrow-bottom-right",
      key: "losses",
      rootRoute: "/losses"
    },
    {
      title: "Clientes",
      icon: "mdi-account-cash-outline",
      key: "customers",
      rootRoute: "/customers"
    },
    {
      title: "Mesas",
      icon: "mdi-table-furniture",
      key: "tables",
      rootRoute: "/tables"
    },
    {
      title: "Productos",
      icon: "mdi-package-variant-closed",
      key: "products",
      rootRoute: "/products"
    },
    {
      title: "Inventario",
      icon: "mdi-clipboard-text-outline",
      key: "stocks",
      rootRoute: "/stocks"
    },
    {
      title: "Sucursales",
      icon: "mdi-store-outline",
      key: "branches",
      rootRoute: "/branches"
    },
    {
      title: "Empleados",
      icon: "mdi-account-group-outline",
      key: "employees",
      rootRoute: "/employees"
    },
    {
      title: "Ajustes",
      icon: "mdi-cog-outline",
      key: "settings",
      rootRoute: "/settings"
    }
  ]
};
